import logo from './logo.svg';
import './App.css';
import HomePage from "./components/HomePage.js";

function App() {
  return (
    <div className="App">
     <HomePage></HomePage>
    </div>
  );
}

export default App;
